export const getActionErrorText = (error: unknown) => {
  if (error instanceof Response) {
    return `response/${error.status}`;
  }

  if (error instanceof Error) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return `error/${error?.status ?? error.message}`;
  }

  return "unknown/error";
};
